import React, { useState } from "react";
import {
  Button,
  Modal,
  Spin,
  List,
  Card,
  Divider,
  Popover,
  Checkbox,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import organizationsActions from "../../../redux/organizations/actions";
import "./index.css";

const AdminOrganizationCheckVersions = ({ userFlag }) => {
  const dispatch = useDispatch();
  const { fbdbversions } = useSelector((state) => state.organizationsReducer);
  const { organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const {
    checkFireBirdDbVersions,
    getFirebirdDatabaseVersionsCloseModal,
    checkFireBirdDbVersionsByUser,
  } = organizationsActions;
  const [isVersionModalOpen, setIsVersionOpen] = useState(false);
  const [showOnlyMyMenu, setShowOnlyMyMenu] = useState(false);

  const versions =
    userFlag === true
      ? fbdbversions.filter((item) =>
          organizations.some((org) => org.id === item.organizationId)
        )
      : fbdbversions;

  const showVersionsModal = () => {
    setIsVersionOpen(true);
  };

  const closeVersionModal = () => {
    dispatch(getFirebirdDatabaseVersionsCloseModal());
    setIsVersionOpen(false);
  };

  const checkOrganizationVersionFunc = () => {
    showVersionsModal();
    if (userFlag) {
      dispatch(checkFireBirdDbVersionsByUser());
    } else {
      dispatch(checkFireBirdDbVersions());
    }
  };

  const onChange = (e) => {
    setShowOnlyMyMenu(e.target.checked);
  };

  // if showMyMenu is false read this value return all organizations
  const groupedVersions = versions.reduce((groups, item) => {
    const group = groups[item.version] || [];
    return { ...groups, [item.version]: [...group, item] };
  }, {});

  const sortedVersions = Object.entries(groupedVersions)
    .sort(([versionA], [versionB]) => {
      return versionB - versionA.substring;
    })
    .reverse();

  // if showMyMenu is true read this value return only organizations with myMenu
  const enabledOrganizations = sortedVersions.flatMap(([version, orgArray]) =>
    orgArray.filter((org) => org.myMenuEnabled)
  );

  // Step 2: Group organizations by version
  const groupedOrganizations = enabledOrganizations.reduce((acc, org) => {
    const version = org.version.toString(); // Ensure version is a string to match `sortedVersions` format
    if (!acc[version]) {
      acc[version] = []; // Initialize if version doesn't exist
    }
    acc[version].push(org);
    return acc;
  }, {});

  // Step 3: Convert the grouped object back to an array of arrays like sortedVersions
  const transformedFilteredOrganizations = Object.entries(groupedOrganizations)
    .map(([version, orgArray]) => [version, orgArray])
    .sort((a, b) => b[0] - a[0]); // Sort by version in descending order

  return (
    <>
      <Button
        type="primary"
        className="admin-organization-check-version-button"
        onClick={checkOrganizationVersionFunc}
      >
        Проверка на версии
      </Button>
      <Modal
        title={
          <>
            <h3 className="admin-organization-check-version-modal-title">
              Проверка версии на бази
            </h3>
            <div className="admin-organization-check-version-modal-title-legend">
              <p className="orange-line" />
              <p>MyMenu</p>
              <Checkbox
                className="admin-organization-check-version-modal-only-mymenu"
                onChange={onChange}
                checked={showOnlyMyMenu}
              />
            </div>
          </>
        }
        className="admin-organization-check-version-modal"
        width="90%"
        footer={null}
        open={isVersionModalOpen}
        onCancel={closeVersionModal}
      >
        <div className="admin-organization-check-version-modal-container">
          {versions.length === 0 ? (
            <div className="admin-organization-check-version-loader-container">
              <Spin />
            </div>
          ) : (
            (showOnlyMyMenu
              ? transformedFilteredOrganizations
              : sortedVersions
            ).map(([version, items]) => (
              <div key={version}>
                <Divider>
                  {version} / {items.length}
                </Divider>
                <List
                  grid={{
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg: 4,
                    xl: 5,
                    xxl: 8,
                  }}
                  dataSource={items}
                  renderItem={(item) => (
                    <List.Item>
                      <Popover content={item.city} trigger="hover">
                        <Card
                          style={{
                            border: item.myMenuEnabled
                              ? "2px solid #fbbc49"
                              : "",
                          }}
                          className="admin-organization-check-version-card"
                        >
                          <p className="admin-organization-check-version-item">
                            {item.name}
                          </p>
                        </Card>
                      </Popover>
                    </List.Item>
                  )}
                />
              </div>
            ))
          )}
        </div>
      </Modal>
    </>
  );
};

export default AdminOrganizationCheckVersions;
